import React from 'react'
import { SocialCard, Icon } from './styles'
import { SocialLabels } from 'src/types'
import { useTranslation } from 'react-i18next'

export const MapSocial = ({ icon, name, link, linkEs }: SocialLabels) => {
    const { i18n } = useTranslation()
    return (
        <>
            {i18n.language === 'es' ? (
                <SocialCard href={linkEs} target={'_blank'}>
                    <Icon src={icon} alt={name} />
                </SocialCard>
            ) : (
                <SocialCard href={link} target={'_blank'}>
                    <Icon src={icon} alt={name} />
                </SocialCard>
            )}
        </>
    )
}
